import React from 'react';
import Responsive from '../Responsive';
import ProductViewBox from '../../windows/Applets/ProductViewBox';

class MySlider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentIndex: 0,
        };
    }


    handleNext = () => {
        const { currentIndex } = this.state;
        const { items } = this.props;
        const nextIndex = (currentIndex + 1) % items.length;
        this.setState({ currentIndex: nextIndex });
    }

    handlePrevious = () => {
        const { currentIndex } = this.state;
        const { items } = this.props;
        const prevIndex = (currentIndex - 1 + items.length) % items.length;
        this.setState({ currentIndex: prevIndex });
    }
    openApplet = () => {
        // let path = [username, urlcode]
        // console.log('ssssss', this.props.addNewWindow)
        this.props.addNewWindow("applet", {}, "center")
    }
    toggle = (open) => {
        console.log('sss555sss', this.props.addNewWindow)
        this.setState({ open: open == null ? !this.state.open : open })
    }


    render() {
        const { currentIndex } = this.state;
        const { items } = this.props;

        const sliderContainerStyles = {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '300px',
            overflow: 'hidden',
            borderRadius: '10px',
        }
        let translateX = -currentIndex * 35;

        const sliderWrapperStyles = {
            display: 'flex',
            transform: `translateX(${translateX}px)`,
            transition: 'transform 0.3s ease',
        };

        return (
            <div className="position-relative">
                <div className="br-15" style={sliderContainerStyles}>
                    <div
                        className=""
                        style={sliderWrapperStyles}
                        onWheel={this.handleMouseScroll}
                    >
                        {items.map((item, index) => (

                            // <Responsive key={index} width={this.props.width} height={'100%'} media={{ xs: '12', 400: '6', 700: '3', lg: '3', xl: '3' }} onClick={() => { this.openApplet(); this.toggle() }}>
                            <Responsive key={index} width={this.props.width} height={'100%'} media={{ xs: '12', 400: '6', 700: '3', lg: '3', xl: '3' }} >
                                <div className='prd-5' style={{ overflow: "hidden" }} onClick={() => this.openApplet()}>
                                    <ProductViewBox data={item} settings={{}} onClick={this.serviceClicked} dashboard={true} />

                                </div>
                            </Responsive>
                        ))}
                    </div>

                </div>
                <div className="px-3 flexcb">
                    <button className='flexcc position-absolute' style={{ background: "#dcdcdc", borderRadius: 50, top: "95%", left: 2 }} onClick={this.handlePrevious}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#222" className='m-1' style={{ width: 20, height: 20 }}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                        </svg>

                    </button>
                    <button className='flexcc position-absolute' style={{ background: "#dcdcdc", borderRadius: 50, top: "95%", right: 2 }} onClick={this.handleNext}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#222" className='m-1' style={{ width: 20, height: 20 }}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                        </svg>

                    </button>
                </div>
            </div>
        );
    }
}

export default MySlider;